<ng-container *ngIf="errorMessage != null else templateErrorMessage">
  {{ errorMessage }}
</ng-container>

<ng-template #templateErrorMessage>
  <ng-content></ng-content>
</ng-template>